var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30pt",
    height: "30pt",
    viewBox: "0 0 480.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1923 3191 c-57 -14 -140 -60 -183 -102 -25 -24 -59 -77 -88 -137 l-48 -97 -355 -5 -355 -5 -75 -37 c-118 -58 -201 -159 -233 -283 -14 -51 -16 -172 -16 -892 0 -578 3 -848 11 -885 35 -164 168 -300 330 -337 60 -14 2918 -14 2978 0 162 37 295 173 330 337 8 37 11 307 11 885 0 720 -2 841 -16 892 -32 124 -115 225 -233 283 l-75 37 -355 5 -355 5 -48 97 c-56 114 -103 165 -197 211 l-66 32 -465 2 c-256 1 -479 -2 -497 -6z m956 -251 c22 -17 52 -64 94 -150 40 -81 72 -132 90 -145 27 -19 48 -20 417 -25 l388 -5 43 -30 c23 -16 52 -48 63 -70 21 -39 21 -51 24 -870 2 -580 0 -841 -8 -868 -14 -49 -65 -106 -115 -128 -38 -18 -108 -19 -1475 -19 -1367 0 -1437 1 -1475 19 -50 22 -101 79 -115 128 -8 27 -10 288 -8 868 3 819 3 831 24 870 11 22 40 54 63 70 l43 30 388 5 c369 5 390 6 417 25 18 13 50 65 89 144 66 132 73 142 119 166 26 13 86 15 466 13 l436 -3 32 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 2450 c-286 -45 -532 -244 -631 -510 -143 -383 17 -803 376 -989 134 -70 204 -86 370 -86 124 0 156 3 220 23 333 104 555 382 577 719 20 319 -156 625 -441 763 -55 27 -130 56 -166 65 -84 19 -229 26 -305 15z m230 -235 c264 -55 454 -290 455 -560 0 -151 -56 -282 -169 -396 -118 -118 -239 -169 -401 -169 -162 0 -283 51 -401 169 -227 228 -226 573 2 802 135 136 326 193 514 154z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1bfc04de425a0c53f86ef1dfe33b9daa.svg";
export { ForwardRef as ReactComponent };